import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { showLoader } from "../../redux/actions/action_loader";
import Button from "@material-ui/core/Button";
import "./Axis_Otp.css";
import { getApiData } from "../../api/api";
import AxisTeleOtp from "./AxisTeleOtp/AxisTeleOtp";
import Snackbar from "../Snackbar/Snackbar";
import { otp_top_img } from "../../images/images";
import Error from "../Error/Error";
import { LinearProgress } from "@material-ui/core";
import AxiosRequest from "../../utils/axios";
import { getConfigFromParamStore, getConfigFromStroage } from "../../utils/getUrlsFromAws";

const axios = new AxiosRequest().getClient()

class Axis_Otp extends Component {
  constructor() {
    super();
    this.state = {
      generatingOtp: false,
      submitting: false,
      disableSubmitButton: true,
      disableGenerateOtpButton: false,
      otp: undefined,
      otpButtonText: "Generate OTP",
      showCallButton: false,
      disableCallButton: false,
      callAttemptsSuccess: 0,
      generateOtpTime: 20,
      callOtpTime: 20,
      showGenerateOtpTime: false,
      showCallTime: false,
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
      displayMessage: "Please click on Generate OTP button to get the OTP.",
      checkboxValue: false,
      verificationError: false,
      errorMessage: "",
      showLoader: true,
      nextstep: "",
      posRefNumOtp: localStorage.getItem("posvRefNumber"),
      IsLinkValid: false,

    };
  }

  componentDidMount() {
    this.startLoad();

    this.props.showLoader(false);
    window.scrollTo(0, 0);
    document.addEventListener("keyup", this.inputFunction);
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.inputFunction);
  }
  startLoad = async() => {
    const txnId = this.props.history.location.search.split("=")[1];
    console.log(txnId);
    if (!txnId) {
      this.setState({
        verificationError: true,
        errMsg: "No Refrence id found",
      });
      return;
    }
    let urlsData = getConfigFromStroage();
    if (!urlsData) {
      const resp = await getConfigFromParamStore()
    }
    this.verifyLink(txnId);
  };

  verifyLink = async (txnId) => {
    this.setState({ showLoader: true });
    const { url, body } = getApiData("validateUploadLink");
    body.request.payload.posvRefNumber = txnId;
    body.request.payload.action = "validation";
    try {
      if (!window.navigator.onLine) {
        throw "Please check your network connection";
      }
      const response = await axios.post(url, body);
      console.log(response);

      let { nextAction, posvRefNumber } = response.data.response.payload;

      let {
        isLinkValid,
        businessMsg,
      } = response.data.response.payload.validationResponsePayload;
      if (isLinkValid) {
        localStorage.setItem("posvRefNumber", posvRefNumber);
      }

      if (isLinkValid === false) {
        this.setState({ errorMessage: businessMsg });
      } else {
        this.setState({
          errorMessage: "",
          nextstep: nextAction,
          IsLinkValid: isLinkValid,
        });
      }
    } catch (err) {
      this.setState({
        verificationError: true,
        errMsg: err,
      });
    } finally {
      this.setState({ showLoader: false });
    }
  };

  inputFunction = () => {
    const [i0, i1, i2, i3] = document.querySelectorAll(".axis-input_otp");
    if (i0.value && i1.value && i2.value && i3.value) {
      this.setState({ disableSubmitButton: false });
    } else {
      this.setState({ disableSubmitButton: true });
    }
  };

  generateOtp = (type) => {
    this.setState({ generatingOtp: true }, async () => {
      let { url, body } = getApiData("getotp");

      body.request.payload.posvRefNumber = localStorage.getItem(
        "posvRefNumber"
      );

      body = JSON.parse(JSON.stringify(body));

      let generateOtpinterval;
      if (type !== "call") {
        this.setState({
          showGenerateOtpTime: true,
          disableGenerateOtpButton: true,
        });
        generateOtpinterval = setInterval(() => {
          this.setState({ generateOtpTime: --this.state.generateOtpTime });
          if (this.state.generateOtpTime === 0) {
            clearInterval(generateOtpinterval);
            this.setState({
              showGenerateOtpTime: false,
              generateOtpTime: 20,
              disableGenerateOtpButton: false,
            });
          }
        }, 1000);
      }

      let callInterval;
      if (type === "call") {
        this.setState({ showCallTime: true, disableCallButton: true });
        body.request.payload.onCallOTP = "Yes";
        callInterval = setInterval(() => {
          this.setState({ callOtpTime: --this.state.callOtpTime });
          if (this.state.callOtpTime === 0) {
            clearInterval(callInterval);
            this.setState({
              showCallTime: false,
              callOtpTime: 20,
              disableCallButton: false,
            });
          }
        }, 1000);
      }

      try {
        this.props.showLoader(true);
        const response = await axios.post(url, body);
        this.setState({
          displayMessage: response.data.response.payload.levelMessage,
        });
        if (type === "call") {
          this.setState(
            { callAttemptsSuccess: this.state.callAttemptsSuccess + 1 },
            () => {
              if (this.state.callAttemptsSuccess >= 3) {
                this.setState({ showCallButton: false });
              }
            }
          );
        }
        const msg = response.data.response.msgInfo.msgDescription;
        this.handleSnackbar(true, "success", msg);
      } catch (err) {
        if (generateOtpinterval) {
          clearInterval(generateOtpinterval);
        }
        if (callInterval) {
          clearInterval(callInterval);
        }

        this.setState({
          showGenerateOtpTime: false,
          generateOtpTime: 20,
          disableGenerateOtpButton: false,
        });
        if (this.state.callAttemptsSuccess >= 3) {
          this.setState({
            showCallTime: false,
            callOtpTime: 20,
            disableCallButton: false,
          });
        }

        this.handleSnackbar(true, "error", "Please try again");
      } finally {
        this.props.showLoader(false);
        this.setState({
          generatingOtp: false,
          showCallButton: true,
          otpButtonText: "Regenerate OTP",
        });
      }
    });
  };


  submit = async () => {
    this.props.showLoader(true);
    this.setState({ submitting: true });
    try {
      await this.SubmitOtp();
    } catch (err) {
      this.props.showLoader(false);
      this.setState({ submitting: false });
      this.handleSnackbar(
        true,
        "error",
        "Something went wrong. Please try again"
      );
    }
  };

  SubmitOtp = async () => {
    const inps = document.getElementsByClassName("axis-input_otp");
    let otp = "";
    for (let inp of inps) {
      otp += inp.value;
    }
    const { url, body } = getApiData("validateOtp");
    body.request.payload.otp = otp;
    body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");

    try {
      const res = await axios.post(url, body);
      if (res.data.response.messageInfo.msgCode === "700") {
        this.setState({ submitting: false });
        this.handleSnackbar(
          true,
          "error",
          res.data.response.messageInfo.msgDescription
        );
        return;
      }
      document.removeEventListener("keyup", this.inputFunction);
      this.setState({ submitting: false });

      if (res.data.response.messageInfo.msgCode === "200") {
        let { url, body } = getApiData("validateUploadLink");
        body.request.payload.posvRefNumber = localStorage.getItem(
          "posvRefNumber"
        );
        body.request.payload.action = "documentList";
        console.log("verify", body);
        const response = await axios.post(url, body);
        console.log(response);
        let {
          nextAction,
          documentList,
          businessMsg,
        } = response.data.response.payload;


        if (documentList === undefined || documentList.length === 0) {
          this.setState({ submitting: false, errorMessage: businessMsg });
        } else if (
          nextAction === "upload" &&
          documentList.length !== 0 &&
          documentList !== undefined
        ) {
          JSON.stringify(documentList);
          localStorage.setItem("documentList", JSON.stringify(documentList));
          this.props.history.push("/uploaddocument");
        } else {
          this.setState({ submitting: false, errorMessage: businessMsg });
        }
      }
    } catch (err) {
      this.setState({ submitting: false });
      this.handleSnackbar(
        true,
        "error",
        "Something went wrong. Please check otp and try again"
      );
    } finally {
      this.props.showLoader(false);
    }
  };

  handleSnackbar = (showSnackbar, snackbarMsgType, snackbarMsg) => {
    this.setState({ showSnackbar, snackbarMsgType, snackbarMsg });
    setTimeout(() => {
      this.closeSnackbar();
    }, 2500);
  };

  closeSnackbar = () => {
    this.setState({
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
    });
  };

  render() {
    const { errorMessage, showLoader, nextstep, IsLinkValid } = this.state;
    console.log({ errorMessage, showLoader, nextstep });

    return (
      <>
        {errorMessage === "" && nextstep === "OTP" && IsLinkValid === true ? (
          showLoader ? (
            <>
              <LinearProgress style={{ visibility: "visible" }} />
              <div className="display_text">Please wait...</div>
            </>
          ) : (
            <div>
              {this.state.showSnackbar ? (
                <Snackbar
                  closeSnackbar={this.closeSnackbar}
                  snackbarMsgType={this.state.snackbarMsgType}
                  snackbarMsg={this.state.snackbarMsg}
                />
              ) : null}
              <div className="axis-dsclmr-wrap">
                <div className="axis-generate-otp__grid">
                  <div>
                    <img src={otp_top_img} alt="Cell Phone" />
                    <p className="axis-default_text">{this.state.displayMessage}</p>
                    <h4 className="axis-default_text">Enter 4 - Digit code</h4>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <AxisTeleOtp submitting={this.state.submitting} />
                  </div>

                  <div className="axis-buttons_div__otp">
                    <div className="axis-btn-time">
                      <Button
                        variant="contained"
                        disabled={
                          this.state.submitting ||
                          this.state.disableGenerateOtpButton
                        }
                        className="axis-default_button"
                        onClick={() => this.generateOtp("generate")}
                      >
                        {this.state.otpButtonText}
                      </Button>
                      {this.state.showGenerateOtpTime ? (
                        <span className="axis-otpTime">
                          {this.state.generateOtpTime}
                        </span>
                      ) : null}
                    </div>

                    {this.state.showCallButton ? (
                      <div className="axis-btn-time">
                        <Button
                          variant="contained"
                          disabled={
                            this.state.submitting ||
                            this.state.disableCallButton
                          }
                          className="axis-default_button"
                          id="call_button"
                          onClick={() => this.generateOtp("call")}
                        >
                          Get OTP on Call
                        </Button>
                        {this.state.showCallTime ? (
                          <span className="axis-otpTime">
                            {this.state.callOtpTime}
                          </span>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                  {this.state.channelName === "x" ? (
                    <Button
                      style={{ justifyContent: "center", display: "flex" }}
                      variant="contained"
                      className="axis-default_button axis-submit_button--generate_otp"
                      onClick={this.submit}
                      disabled={
                        this.state.submitting || this.state.disableSubmitButton
                      }
                    >
                      Submit
                    </Button>
                  ) : null}
                </div>
                {this.state.channelName !== "x" ? (
                  <div className="axis-tnc-txt">
                    <form>
                      {/* <fieldset>
                                    <input disabled={this.state.submitting} type="checkbox" value={this.state.checkboxValue} onChange={event => this.handleCheckbox(event.target.checked)} />
                                    <p className="check-sec">
                                        {disclaimerTextForGenOtp}
                                    </p>
                                </fieldset> */}
                      <Button
                        variant="contained"
                        className="axis-default_button axis-submit_button--generate_otp"
                        onClick={this.submit}
                        disabled={
                          this.state.submitting ||
                          this.state.disableSubmitButton
                        }
                      >
                        Submit
                      </Button>
                    </form>
                  </div>
                ) : null}
              </div>
            </div>
          )
        ) : (
          <Error errorMsg={errorMessage} />
        )}
      </>
    );
  }
}

export default compose(withRouter, connect(null, { showLoader }))(Axis_Otp);